import { render, staticRenderFns } from "./publishSurveyForms.vue?vue&type=template&id=5f0d2c4a&scoped=true"
import script from "./publishSurveyForms.vue?vue&type=script&lang=js"
export * from "./publishSurveyForms.vue?vue&type=script&lang=js"
import style0 from "./publishSurveyForms.vue?vue&type=style&index=0&id=5f0d2c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0d2c4a",
  null
  
)

export default component.exports